module.exports = __webpack_public_path__ + "static/media/icon-message-white.4cd62c8f.svg";